/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsImageSlider = {
    init: function ($section) {
      $section.find('[data-slider]').each(function () {
        const $slider = $(this);
  
        $slider.flickity({
          lazyLoad: 2,
          freeScroll: false,
          imagesLoaded: true,
          draggable: true,
          cellAlign: 'left',
          wrapAround: false,
          pageDots: false,
          contain: true,
          prevNextButtons: false,
          initialIndex: 0
        });
  
        const flkty = $slider.data('flickity'); // Get Flickity instance
        const progressBar = $slider.closest('.image-slider-wrapper').find('.pb-gallery-bar')[0];
  
        if (progressBar) {
          flkty.on('scroll', function (progress) {
            progress = Math.max(0, Math.min(1, progress));
            progressBar.style.width = progress * 100 + '%';
          });
        }
  
        $slider.on('settle.flickity', function () {
          $slider.flickity('resize');
        });
      });
    },
    unload: function ($section) {}
  }

  /******/
})()
  ;